import { usePageModels } from '@/context/PageModels';
import { Theme } from '@/utils/constants';
import resolveImageUrl from '@/utils/resolvers/resolveImageUrl';
import clsx from 'clsx';
import { get } from 'lodash/fp';
import React, { useMemo } from 'react';
import { MuiTypography } from '../material-ui';
import usePartnerOnlyStyles from './PartnerOnly.styles';

interface PartnerOnlyProps {
  className?: string;
  blueLabel?: boolean;
  onlyIcon?: boolean;
  theme?: Theme;
}

const PartnerOnly = ({
  className,
  blueLabel = false,
  onlyIcon = false,
  theme = Theme.light,
}: PartnerOnlyProps) => {
  const classes = usePartnerOnlyStyles();
  const { config, labels } = usePageModels();
  const { ssoPartnerOnlyLabel } = labels?.sso || {};

  const partnerIconsPath = useMemo(
    () => ({
      dark: resolveImageUrl({ raw: get(['sso', 'ssoPartnerOnlySmallIcon-light'], config) }),
      light: resolveImageUrl({ raw: get(['sso', 'ssoPartnerOnlySmallIcon-dark'], config) }),
    }),
    [config],
  );

  return (
    <MuiTypography component="span" className={clsx(classes.root, className, `${theme}-theme`)}>
      <img className={clsx('icon')} src={get(theme, partnerIconsPath)} alt="" />
      {!onlyIcon && (
        <MuiTypography
          className={clsx('label', {
            'blue-label': blueLabel,
          })}
          component="span"
        >
          {ssoPartnerOnlyLabel || 'Partner Only'}
        </MuiTypography>
      )}
    </MuiTypography>
  );
};

export default PartnerOnly;
